import { render } from "./slidesdb_chap07_en.vue?vue&type=template&id=3bdaf7ba&scoped=true"
import script from "./slidesdb_chap07_en.vue?vue&type=script&lang=js"
export * from "./slidesdb_chap07_en.vue?vue&type=script&lang=js"

import "@/assets/css/globalen.css?vue&type=style&index=0&id=3bdaf7ba&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdaf7ba"]])

export default __exports__